// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
    production: false,
    // host: 'http://localhost:60102/api/web',
    host: "https://dev.finamsa.com.py:60102/api/web",
    API_USERNAME: "f1n3xUs",
    API_PASSWORD: "f1n3xUsf1n4ms422",
    SECRET_KEY: "f1n3xUs.2022",
    // SECRET_KEY: 'Fin4m54.2025*',
    // WhatsApp Cloud API (Meta). Identificadores PUBLICOS de la aplicacion:
    // el App Secret NUNCA va en el frontend, vive solo en el backend.
    META_APP_ID: "643645284995942",
    // Configuration ID del Facebook Login for Business, creado en Meta Business Suite.
    META_CONFIG_ID: "1551747396270172",
    META_GRAPH_VERSION: "v26.0",

    VERSION: "2.5.8",
    FECHA: "02/10/2026",
};
